module.exports = __webpack_public_path__ + "static/media/gerda_imhof_mood.e14ffaa3.jpg";